import {useQuery} from "@tanstack/react-query";

import {panicAlertsService} from "../services";

export function usePanicAlert(id?: number | null) {
  const query = useQuery({
    queryKey: ["panic-alert", id],
    queryFn: () => panicAlertsService.show(id!),
    enabled: id != null,
  });

  return {
    panicAlert: query.data,
    isPending: query.isPending,
    isFetching: query.isFetching,
    refetch: query.refetch,
  };
}

export function usePanicAlertStatistics(enabled = true) {
  const query = useQuery({
    queryKey: ["panic-alert-statistics"],
    queryFn: () => panicAlertsService.statistics(),
    enabled,
  });

  return {
    stats: query.data,
    isPending: query.isPending,
    isFetching: query.isFetching,
    refetch: query.refetch,
  };
}
